import { render, staticRenderFns } from "./StudyEffectivenessMobile.vue?vue&type=template&id=d3cce342&scoped=true"
import script from "./StudyEffectivenessMobile.vue?vue&type=script&lang=js"
export * from "./StudyEffectivenessMobile.vue?vue&type=script&lang=js"
import style0 from "./StudyEffectivenessMobile.vue?vue&type=style&index=0&id=d3cce342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cce342",
  null
  
)

export default component.exports